export default {
  delete: { text: 'Delete' },
  delete_selected_flag_tooltip: { tooltip: 'Delete selected flag' },
  add_flag_tooltip: { tooltip: 'Add a flag with current latitude, longitude and name' },
  are_you_sure: { text: 'Are you sure about deleting this flag?' },
  delete_title_confirm: { text: 'Delete flag' },
  default_selected_flag: { text: 'None' },
  selected_flag: { text: 'Nearest flag:' },
  add_point_interest_abstract: { text: 'Add or update your point of interest here with a latitude, a longitude and a name of choice.' },
  insert_name: { text: 'Name:' },
  add_point_interest: { text: 'Add point of interest' },
  add: { text: 'Add' },
  place_search_term: { text: 'Search for location&hellip;' },
  debug_searching_location: { text: 'Searching for location in SQLite DB:' },
  debug_searching_sqlite_location: { text: 'Searching for location with GeoNames API:' },
  geonames_api_call_failed: { text: 'GeoNames API request failed' },
  geonames_sqlite_call_failed: { text: 'GeoNames SQLite request failed.' },
  no_results_search: { text: 'No results for search' },
  unable_to_do_getcapabilities: { text: 'Unable to do getcapabilities for' },
  unable_to_connect_server: { text: 'Unable to connect to the service.' },
  unable_to_search: { text: 'Unable to perform a search' },
  no_urls_in_config: { text: 'No GeoNames URLs defined in config file' },
  only_alpha_num_allowed: { text: 'Search may only contain alpha numeric characters' },
  no_search_definition: { text: 'Search term is empty' },
  result: { text: 'Result' },
  service_has_error: { text: '--- service has an error ---' },
  no_time_dimension_in_layer: { text: 'No time dimension found in this layer' },
  no_service_defined: { text: 'No service defined' },
  service_url_empty: { text: 'Service URL is empty' },
  wms_service_exception_code: { text: 'WMS Service exception with code ' },
  unnamed_service: { text: 'Unnamed service' },
  add_layers: { text: 'Add layers&hellip;', tooltip: 'Add new datasets, layers and services' },
  add_custom_service: { text: 'Add a custom version 1.1.1 Web Map Service (WMS)' },
  properties_for: { text: 'Properties for' },
  color_range: { text: 'Color range' },
  reset: { text: 'Reset' },
  apply: { text: 'Apply' },
  min_value: { text: 'Min value' },
  max_value: { text: 'Max value' },
  wms_version: { text: 'WMS version' },
  wms_comp_mode: { text: 'WMS 1.3.0 BBOX compatibility mode' },
  projections: { text: 'Projections' },
  projection: { text: 'Projection' },
  epsg_code: { text: 'EPSG Code' },
  bounding_box: { text: 'Bounding Box' },
  file_metadata: { text: 'File metadata' },
  show_file_metadata: { text: 'Show file metadata' },
  download_data_wcs: { text: 'Download data via WCS' },
  coordinate_reference_system: { text: 'Coordinate reference system' },
  area_bounding_box: { text: 'Area / Bounding box' },
  dimensions: { text: 'Dimensions' },
  dimension: { text: 'Dimension' },
  formats: { text: 'Formats' },
  north: { text: 'North' },
  west: { text: 'West' },
  east: { text: 'East' },
  south: { text: 'South' },
  cell_size: { text: 'Cell size' },
  x_resolution: { text: 'X Resolution' },
  y_resolution: { text: 'Y Resolution' },
  raster_size: { text: 'Raster size' },
  raster_width: { text: 'Raster width' },
  raster_height: { text: 'Raster height' },
  format: { text: 'Format' },
  show: { text: 'Show' },
  create_permanent_links: { text: 'Create permanent links' },
  please_select_product: { text: 'Please select a product' },
  no_capability_element_found: { text: 'No Capability element found in service' },
  no_wms_capability_element_found: { text: 'No WMS Capability element found' },
  no_wms_layer_element_found: { text: 'No WMS Layer element found' },
  settings_and_options: { tooltip: 'Settings and options' },
  show_time_selection_window: { text: 'Show time selection window&hellip;' },
  create_animation: { text: 'Create animation&hellip;' },
  create_link: { text: 'Create link&hellip;' },
  show_debug_information: { text: 'Show debug information&hellip;' },
  add_custom_wms_service: { text: 'Add custom WMS service&hellip;' },
  undo_zoom_pan_action: { text: 'Undo zoom/pan action' },
  redo_zoom_pan_action: { text: 'Redo zoom/pan action' },
  abort_loading: { text: 'Abort loading' },
  about_the_adaguc_viewer: { text: 'About the ADAGUC viewer', tooptip: 'Display info about the ADAGUC viewer' },
  about_adaguc: { text: 'About ADAGUC' },
  about_adaguc_more_information: { text: '<br/><br/>Please visit <a target="_blank" href="http://adaguc.knmi.nl/">http://adaguc.knmi.nl/</a> for more information.<div>' },
  layers: { text: 'Layers', tooltip: 'Layers' },
  predefined_areas: { tooltip: 'Select predefined areas' },
  basemaps_overlays: { tooltip: 'Select basemaps and overlays' },
  add_layers_and_services: { text: 'Add Layers and Services' },
  add_new_layer: { tooltip: 'Add new layer' },
  clone_this_layer: { tooltip: 'Clone this layer and place it on top of the layerlist' },
  remove_this_layer: { tooltip: 'Remove this layer' },
  move_layer_up: { tooltip: 'Move this layer up in the list and the map view' },
  move_layer_down: { tooltip: 'Move this layer down in the list and the map view' },
  title: { text: 'Title' },
  layer: { text: 'Layer' },
  type: { text: 'Type' },
  name: { text: 'Name' },
  abstract: { text: 'Abstract' },
  service: { text: 'Service' },
  description: { text: 'Description' },
  no_dimensions_available: { text: 'No layers with a time dimension available.' },
  load_all: { text: 'Load all' },
  play_animation: { text: 'Play animation' },
  stop: { text: 'Stop' },
  start: { text: 'Start' },
  opacity: { text: 'Opacity:' },
  zoom_to_this_layer: { tooltip: 'Zoom to this layer' },
  start_or_stop_animation: { tooltip: 'Start or stop animation' },
  reload_this_layer: { tooltip: 'Reload this layer' },
  layer_properties: { tooltip: 'Layer properties' },
  hide_or_display_layer: { tooltip: 'Hide or display this layer' },
  select_layer_product_from_service: { tooltip: 'Select a layer or product from the service' },
  change_style_layer: { tooltip: 'Change the style of this layer' },
  available_styles: { text: 'Available styles' },
  no_styles_available: { text: 'No styles available' },
  default: { text: 'Default' },
  embed: { text: 'Embed' },
  time_selection: { text: 'Time selection' },
  local_time: { text: 'Local time' },
  year: { text: 'Year' },
  month: { text: 'Month' },
  day: { text: 'Day' },
  hour: { text: 'Hour' },
  min: { text: 'Min' },
  select_layer: { text: 'Select layer' },
  select_dimension: { text: 'Select dimension' },
  start_at: { text: 'Start at' },
  number_of_steps: { text: 'Number of steps' },
  delay_ms: { text: 'Delay (ms)' },
  enter_wms_version_url: { text: 'Enter WMS version 1.1.1 URL here...' },
  enter_search_term: { text: 'Enter your location here&hellip;' },
  not_available_message: { text: 'Not available' }
};
